import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { currentUser, User } from '../../../../../core/auth';
import { QualityTypeService } from '../../../../../core/plant-configuration/_services/quality-type.service';
import { AppState } from '../../../../../core/reducers';
import { LayoutUtilsService, QueryParamsModel, QueryResultsModel } from '../../../../../core/_base/crud';
import { SubheaderService } from '../../../../../core/_base/layout';

@Component({
	selector: 'kt-quality-type-list',
	templateUrl: './quality-type-list.component.html',
	styleUrls: []
})
export class QualityTypeListComponent implements OnInit, OnDestroy, AfterViewInit {


	// displayedColumns = ['select', 'active', 'login', 'group_name','login_date', 'actions'];
	filterList = [
	];
	columnList = [	
        { name: 'id', displayid: 'Id', def: 'id'},
		{ name: 'name', displayName: 'Nombre', def: 'name'},
	];
	actionBtns = [];
	inited = false;
	dataObs: Subject<QueryResultsModel> = new Subject<QueryResultsModel>();
	deleteObs: Subject<string> = new Subject<string>();
	subscriptions: Subscription[] = [];
	lastQuery: QueryParamsModel;
	
	constructor(
		private qualityTypeService: QualityTypeService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private layoutUtilsService: LayoutUtilsService,
		private subheaderService: SubheaderService,
		private cdr: ChangeDetectorRef,
		private store: Store<AppState>,
	) { }

	ngOnInit() {
		this.inited = true;
	}

	deleteOne(qualityTypeId: number) {
		this.subscriptions.push(
			of(null).pipe(
				switchMap(() => this.qualityTypeService.delete({ id: qualityTypeId }))
			).subscribe(status => {
				this.deleteObs.next(status);
			})
		);
	}

	getPage(query: QueryParamsModel) {
		// this.lastQuery = Object.assign(query, {filter: Object.assign(query.filter, {is_installation_contact: 'true'})});
		// console.log(`query get page: ${JSON.stringify(query)}`);
		if(query.sortField == null) query.sortField = "id";
		// console.log(`query get page after: ${JSON.stringify(query)}`);

		this.subscriptions.push(
			of(null).pipe(
				switchMap(() => this.qualityTypeService.getPage(query))
			).subscribe(res => {
				// console.log(`query result: ${JSON.stringify(res)}`);
				this.dataObs.next(res);
			})
		);
	}

	refresh() {
		this.getPage(this.lastQuery);
	}

	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}

	ngAfterViewInit() {
	}
}